<template>
    <div class="container">
        <h1 class="title">404</h1>
        <div class="content">
            <p class="fun-fact">
                100% of people who came across this page didn't find what they're looking for
            </p>
            <div class="chart">
                <apex-charts type="bar" height="200" :options="notFoundDataSource.chartOptions"
                             :series="notFoundDataSource.series"></apex-charts>
            </div>
        </div>
    </div>
</template>

<script>

    import VueApexCharts from "vue-apexcharts/src";

    export default {
        components: {
            'apex-charts': VueApexCharts,
        },
        data: function () {
            return {
                notFoundDataSource: {
                    chartOptions: {
                        chart: {
                            toolbar: {
                                show: false
                            }
                        },
                        colors: ['#008AD0', '#F7941D'],
                        plotOptions: {
                            bar: {
                                horizontal: true,
                                distributed: true,
                                dataLabels: {
                                    position: 'bottom',
                                },
                            }
                        },
                        legend: {
                            labels: {
                                color: '#FFF'
                            }
                        },
                        yaxis: {
                            labels: {
                                style: {
                                    colors: ['#FFF', '#FFF', '#FFF', '#FFF', '#FFF', '#FFF', '#FFF'],
                                },
                            }
                        },
                        xaxis: {
                            categories: [
                                'Found 404', 'Found something useful'
                            ],
                            labels: {
                                style: {
                                    colors: ['#FFF'],
                                },
                            }
                        },
                        dataLabels: {},
                        tooltip: {
                            theme: 'dark'
                        }
                    },
                    series: [{
                        name: 'People on this site',
                        data: [100, 0]
                    }]
                },
            }
        },
        methods: {
            track() {
                this.$ga.page('/2018/404') // This is for Google Analytics tracking
            }
        }
    }


</script>

<style lang="scss" scoped>
    .container {
        display: grid;
        grid-template-columns: 1fr 600px 1fr;
        grid-template-rows: auto 1fr;
        grid-template-areas: '. title .' 'content content content';
        color: white;
        text-align: center;
        background-size: cover;
        background-position: center;
        padding-bottom: 48px;

        @media only screen and (max-width: $screen-sm-max) {
            grid-template-columns: 1fr 2fr 1fr;
        }

        .title {
            grid-area: title;
            align-self: center;
            justify-self: center;
            align-content: center;
            justify-content: center;
            margin: 24px;
            display: grid;
        }

        .content {
            grid-area: content;
            display: grid;
            grid-template-areas: '. chart fact .';
            grid-template-columns: 1fr 1fr 1fr 1fr;
            grid-template-rows: auto auto;
            grid-gap: 16px;

            @media only screen and (max-width: $screen-md-max) {
                grid-template-columns: 1fr 2fr 2fr 1fr;
            }

            @media only screen and (max-width: $screen-sm-max) {
                grid-template-columns: 1fr 3fr 3fr 1fr;
            }

            @media only screen and (max-width: $screen-xs-max) {
                grid-template-areas: '. chart .' '. fact .';
                grid-template-columns: 32px 1fr 32px;
                grid-gap: 0;
            }

            .fun-fact {
                grid-area: fact;
                align-self: center;
                justify-self: center;
                margin: 24px;
            }

            .chart {
                grid-area: chart;
                width: 360px;
                align-self: center;
                justify-self: center;

                @media only screen and (max-width: $screen-xs-max) {
                    width: 250px;
                }
            }

        }
    }
</style>
